<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Hair schedule</h1>
        <p id="role">UX/UI/GUI design, Branding<br />2015</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />헤어샵 단골 디자이너와 고객과의 시간예약
          서비스
        </p>
        <p id="name">
          <b>Planning:</b> Sinjoo Yoon<br /><b>UX/UI/GUI Design:</b> Yuri Ahn
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/hair/01.svg" />
        <img src="/images/portfolios/hair/02.svg" />
        <img src="/images/portfolios/hair/03.svg" />
        <img src="/images/portfolios/hair/04.svg" />
        <img src="/images/portfolios/hair/05.svg" />
        <img src="/images/portfolios/hair/06.svg" />
        <img src="/images/portfolios/hair/07.svg" />
        <img src="/images/portfolios/hair/08.svg" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('mooovr')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('experience-elements')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailHairSchedule",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/hair/top.jpg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
